import { render } from "./prev-reg-dialog.vue?vue&type=template&id=3b41da29&scoped=true&ts=true"
import script from "./prev-reg-dialog.vue?vue&type=script&lang=ts"
export * from "./prev-reg-dialog.vue?vue&type=script&lang=ts"

import "./prev-reg-dialog.vue?vue&type=style&index=0&id=3b41da29&scoped=true&lang=css"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b41da29"]])

export default __exports__